export const FILENAME_REGEX = /^[A-Za-z0-9_ ÄÖÜäöüß]{1,30}$/

export function filenameIsValid(fileName: string): boolean {
  const convertedFileName = skipCharacters(fileName.replace(/\.[^/.]+$/, '')).substring(0, 30)
  const trimmedLength = convertedFileName.trim().length
  if (trimmedLength == 0) {
    return false
  }

  return FILENAME_REGEX.test(convertedFileName)
}

function isDigit(ch: string): boolean {
  return ch >= '0' && ch <= '9'
}

function isLowerLetter(ch: string): boolean {
  return ch.length === 1 && !!ch.match(/[a-z]/i)
}

function isUpperLetter(ch: string): Boolean {
  return ch.length === 1 && !!ch.match(/[A-Z]/i)
}

function isSpecialChar(ch: string): Boolean {
  return ch == '_' || ch == ' '
}

function isGermanCharacter(ch: string): Boolean {
  return (
    ch == '\u00C4' ||
    ch == '\u00D6' ||
    ch == '\u00DC' ||
    ch == '\u00E4' ||
    ch == '\u00F6' ||
    ch == '\u00FC' ||
    ch == '\u00DF'
  )
}

function isSupported(ch: string): Boolean {
  return isDigit(ch) || isLowerLetter(ch) || isUpperLetter(ch) || isSpecialChar(ch) || isGermanCharacter(ch)
}

function skipCharacters(baseName: string): string {
  const builder: string[] = []
  for (const element of baseName.split('')) {
    if (isSupported(element)) {
      builder.push(element)
    }
  }
  return builder.join('')
}
